'use client';

import { useEffect } from 'react';

export default function ViewTracker({ postId }: { postId: number }) {
  useEffect(() => {
    // Only increment view once per load
    const trackView = async () => {
      try {
        const wpApiUrl = process.env.NEXT_PUBLIC_WORDPRESS_API_URL?.replace('/graphql', '') || 'https://admin.myjobs.al';
        
        // Hit our custom REST API endpoint to reliably bypass caching and nonces
        await fetch(`${wpApiUrl}/wp-json/myjobs/v1/view/${postId}`, {
          method: 'POST'
        });
      } catch (e) {
        // Ignore errors for view tracking
      }
    };

    trackView();
  }, [postId]);

  return null;
}
